export type LeadLogType = {
  id: number;
  leadLogType: LeadLogEnum;
  leadSource: string;
  leadId: string;
  ghlId?: string | null;
  oldStatus?: string | null;
  newStatus?: string | null;
  notes?: string | null;
  createdAt: string;
  modifiedAt: string;
};

export enum LeadLogEnum {
  LEAD_CREATED = 'lead-create',
  LEAD_CONTACT_CREATED = 'lead-contact-create',
  LEAD_CONTACT_NOT_CREATED = 'lead-contact-create-failed',
  LEAD_STATUS_UPDATED = 'lead-status-update',
  LEAD_STATUS_UPDATED_FAILED = 'lead-status-update-failed',
  LEAD_NOTES_UPDATED = 'lead-notes-updated',
  LEAD_PIPELINE_STAGE_UNKNOWN = 'lead-pipeline-stage-unknown',
}
